// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1XLm9","infoBtn":"quickbooks_infoBtn__38b12","formBox":"quickbooks_formBox__3wsnO","formFooter":"quickbooks_formFooter__1mXZ1"};